import React from "react";
import { Filter, TextInput } from "react-admin";

export const GeneralQueryFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by name" source="name" alwaysOn />
  </Filter>
);
